"use client";

import * as React from "react";
import {cn} from "../cn";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
   React.ElementRef<typeof TooltipPrimitive.Content>,
   React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({className, sideOffset = 4, ...props}, ref) => (
   <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
         ref={ref}
         sideOffset={sideOffset}
         avoidCollisions={true}
         collisionPadding={8}
         sticky="always"
         className={cn(
            "data-[side=left]:slide-in-from-right-2",
            "data-[side=top]:slide-in-from-bottom-2",
            "z-50",
            "bg-panel_secondary",
            "drop-shadow-md",
            "data-[side=bottom]:slide-in-from-top-2",
            "data-[side=right]:slide-in-from-left-2",
            "px-3",
            "py-1.5",
            "rounded-md",
            "overflow-hidden",
            "max-w-80",
            "break-words",
            "whitespace-normal",
            "text-800",
            "text-xs",
            "origin-[--radix-tooltip-content-transform-origin]",
            "animate-in",
            "data-[state=closed]:animate-out",
            "fade-in-0",
            "zoom-in-[0.97]",
            "duration-150",
            "ease-out",
            "data-[state=closed]:fade-out-0",
            "data-[state=closed]:zoom-out-[0.97]",
            "data-[instant]:duration-0",
            className
         )}
         {...props}
      />
   </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {Tooltip, TooltipTrigger, TooltipContent, TooltipProvider};
